import React, { useState } from "react";
import BlogContent from "./blogContent";
import styles from "./education.module.css";

const educationPosts = [
  {
    id: 0,
    title: "Sports Bra Designs - Encapsulation",
    image: "Encapsulation.png",
  },
  {
    id: 1,
    title: "Sports Bra Designs - Crop Top",
    image: "Crop top.png",
  },
  {
    id: 2,
    title: "Sports Bra Designs - Hybrid",
    image: "Hybrid.png",
  },
  {
    id: 3,
    title: "Breast Support Facts",
    image: "Breast support facts.png",
  },
  {
    id: 4,
    title: "Breast Movement Facts",
    image: "breastMovementBlogPost.png",
    footer: `Further information: Breast Health Module, AIS Female Performance Health Initiative (https://www.ais.gov.au/fphi)
1: McGhee & Steele, Biomechanics of breast support for active women, ESSR, 2020.
Prepared by Professor Deirdre McGhee, Breast Research Australia`,
  },
  {
    id: 5,
    title: "Bra-related Chafing",
    image: "Bra-related chafing.png",
    footer: `Further information: Breast Health Module, AIS Female Performance Health Initiative (https://www.ais.gov.au/fphi)
1: McGhee & Steele, Biomechanics of breast support for active women, ESSR, 2020.
Prepared by Professor Deirdre McGhee, Breast Research Australia`,
  },
  {
    id: 6,
    title: "Breast Pain",
    image: "Breast pain.png",
    footer: `Further information: Breast Health Module, AIS Female Performance Health Initiative (https://www.ais.gov.au/fphi)
1: McGhee & Steele, Biomechanics of breast support for active women, ESSR, 2020.
Prepared by Professor Deirdre McGhee, Breast Research Australia`,
  },
  {
    id: 7,
    title: "Breast Cancer",
    image: "Breast cancer.png",
    footer: `Further information: Breast Health Module, AIS Female Performance Health Initiative (https://www.ais.gov.au/fphi)
1: McGhee & Steele, Biomechanics of breast support for active women, ESSR, 2020.
Prepared by Professor Deirdre McGhee, Breast Research Australia`,
  },
  {
    id: 8,
    title: "Pregnancy and Breastfeeding",
    image: "Breastfeeding.png",
    footer: `Further information: Breast Health Module, AIS Female Performance Health Initiative (https://www.ais.gov.au/fphi)
1: McGhee & Steele, Biomechanics of breast support for active women, ESSR, 2020.
Prepared by Professor Deirdre McGhee, Breast Research Australia`,
  },
  {
    id: 9,
    title: "How to care for your bra",
    image: "how to care for your bra.png",
    footer: `Further information: Breast Health Module, AIS Female Performance Health Initiative (https://www.ais.gov.au/fphi)
1: McGhee & Steele, Biomechanics of breast support for active women, ESSR, 2020.
Prepared by Professor Deirdre McGhee, Breast Research Australia`,
  },
];

export default function Education() {
  const [selectedPostId, setSelectedPostId] = useState(educationPosts[0].id);
  const selectedPost = educationPosts.find(
    (post) => post.id === selectedPostId
  );

  return (
    <div className={styles.educationPage}>
      <aside className={styles.educationSidebar}>
        <h2 className={styles.educationSidebarTitle}>Posts</h2>
        <nav className={styles.educationNav}>
          {educationPosts.map((post) => (
            <button
              key={post.id}
              onClick={() => setSelectedPostId(post.id)}
              className={`${styles.educationNavItem} ${
                selectedPostId === post.id ? styles.active : ""
              }`}
            >
              {post.title}
            </button>
          ))}
        </nav>
      </aside>

      <main className={styles.educationMain}>
        <BlogContent {...selectedPost} />
      </main>
    </div>
  );
}
